/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cascade_Dialog_Auto_HelpInputs */



/**
* | output |
* | --- |
* | "The primary production system (or group) starts first. If backup is needed, the others take over through automatic changeover. Without a defined priority, al..." |
*
* @param {Cascade_Dialog_Auto_HelpInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const cascade_dialog_auto_help = /** @type {((inputs?: Cascade_Dialog_Auto_HelpInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cascade_Dialog_Auto_HelpInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("The primary production system (or group) starts first. If backup is needed, the others take over through automatic changeover. Without a defined priority, all production systems (or groups) are changed over automatically.")
	return /** @type {LocalizedString} */ ("Le système (ou groupe) de production prioritaire démarre en premier. En cas de besoin d’appoint, les autres prennent le relais par permutation automatique. Sans priorité définie, tous les systèmes (ou groupes) de production sont permutés automatiquement.")
});